import { useState, useCallback } from 'react';

const CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
const SCOPES = 'https://www.googleapis.com/auth/calendar.events';

let tokenClient = null;

export function useGoogleCalendar() {
  const [accessToken, setAccessToken] = useState(() => {
    return sessionStorage.getItem('gcal_token') || null;
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const initTokenClient = useCallback(() => {
    return new Promise((resolve, reject) => {
      if (!window.google) {
        reject(new Error('Google Identity Services não carregado'));
        return;
      }
      if (!tokenClient) {
        tokenClient = window.google.accounts.oauth2.initTokenClient({
          client_id: CLIENT_ID,
          scope: SCOPES,
          callback: (response) => {
            if (response.error) {
              reject(response);
              return;
            }
            const token = response.access_token;
            setAccessToken(token);
            sessionStorage.setItem('gcal_token', token);
            resolve(token);
          },
        });
      }
      resolve(null);
    });
  }, []);

  const requestToken = useCallback(async () => {
    await initTokenClient();
    return new Promise((resolve, reject) => {
      tokenClient.callback = (response) => {
        if (response.error) { reject(response); return; }
        const token = response.access_token;
        setAccessToken(token);
        sessionStorage.setItem('gcal_token', token);
        resolve(token);
      };
      tokenClient.requestAccessToken({ prompt: '' });
    });
  }, [initTokenClient]);

  const criarEvento = useCallback(async (agendamento) => {
    setLoading(true);
    setError(null);
    try {
      let token = accessToken;
      if (!token) {
        token = await requestToken();
      }

      const response = await fetch('/.netlify/functions/create-calendar-event', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ agendamento, accessToken: token }),
      });

      const data = await response.json();

      if (!response.ok) {
        // Token expirado — pedir novo
        if (response.status === 401 || data.error?.includes('invalid')) {
          sessionStorage.removeItem('gcal_token');
          setAccessToken(null);
          const newToken = await requestToken();
          const retry = await fetch('/.netlify/functions/create-calendar-event', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ agendamento, accessToken: newToken }),
          });
          const retryData = await retry.json();
          if (!retry.ok) throw new Error(retryData.error);
          return retryData;
        }
        throw new Error(data.error || 'Erro ao criar evento');
      }

      return data;
    } catch (err) {
      setError(err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  }, [accessToken, requestToken]);

  return { criarEvento, loading, error, isAuthorized: !!accessToken };
}
